import { React, useEffect, useState } from 'react';
import style from './sideBar.module.scss';
import { Link, useRouteMatch, Redirect } from 'react-router-dom';
import {
  AppstoreOutlined,
  UserOutlined,
  ShoppingCartOutlined,
  RightOutlined,
  GlobalOutlined,
  LogoutOutlined,
  EyeOutlined,
  SettingOutlined,
} from '@ant-design/icons';
import { Image } from 'antd';

const SideBar = () => {
  let { path } = useRouteMatch();
  const [route, setRoute] = useState('');
  const users = route === '/admin';
  const sells = route === '/admin/sells';
  const stands = route === '/admin/stands';
  const conference = route === '/admin/conference';
  const visits = route === '/admin/visits';
  const manage = route === '/admin/manage';
  const [redirectLogin, setRedirectLogin] = useState(false);

  useEffect(() => {
    setRoute(window.location.pathname);
  }, []);

  const brandImg = `${process.env.REACT_APP_PUBLIC_ASSETS}/public/rounded_logo_expo.png`;

  const {
    sideBar,
    sdBrand,
    sideBarItems,
    itemLink,
    items,
    itemTitle,
    itemArrow,
    itemTitlePos,
    itemLinkActive,
    logOutItem,
    waveContainer,
    logOutBtn,
    customShapeDivider,
    customShapeDivider2,
    shapeFill,
  } = style;

  const logOut = () => {
    localStorage.clear();
    setRedirectLogin(true);
  };

  return (
    <div className={sideBar}>
      <div className={sdBrand}>
        <Image preview={false} src={brandImg} alt="" />
      </div>
      <div className={sideBarItems}>
        <div className={items}>
          <Link
            to={`${path}`}
            className={`${itemLink} ${users ? itemLinkActive : ''}`}
            onClick={() => setRoute(`${path}`)}
          >
            <div className={itemTitle}>
              <div className={itemTitlePos}>
                <UserOutlined />
                Usuarios
              </div>
            </div>
            <div className={itemArrow}>
              <RightOutlined />
            </div>
          </Link>
          <Link
            to={`${path}/sells`}
            className={`${itemLink} ${sells ? itemLinkActive : ''}`}
            onClick={() => setRoute(`${path}/sells`)}
          >
            <div className={itemTitle}>
              <div className={itemTitlePos}>
                <ShoppingCartOutlined />
                Compras
              </div>
            </div>
            <div className={itemArrow}>
              <RightOutlined />
            </div>
          </Link>
          <Link
            to={`${path}/stands`}
            className={`${itemLink} ${stands ? itemLinkActive : ''}`}
            onClick={() => setRoute(`${path}/stands`)}
          >
            <div className={itemTitle}>
              <div className={itemTitlePos}>
                <AppstoreOutlined />
                Stands
              </div>
            </div>
            <div className={itemArrow}>
              <RightOutlined />
            </div>
          </Link>
          <Link
            to={`${path}/conference`}
            className={`${itemLink} ${conference ? itemLinkActive : ''}`}
            onClick={() => setRoute(`${path}/conference`)}
          >
            <div className={itemTitle}>
              <div className={itemTitlePos}>
                <GlobalOutlined />
                Conferencias
              </div>
            </div>
            <div className={itemArrow}>
              <RightOutlined />
            </div>
          </Link>
          <Link
            to={`${path}/visits`}
            className={`${itemLink} ${visits ? itemLinkActive : ''}`}
            onClick={() => setRoute(`${path}/visits`)}
          >
            <div className={itemTitle}>
              <div className={itemTitlePos}>
                <EyeOutlined />
                Visitas
              </div>
            </div>
            <div className={itemArrow}>
              <RightOutlined />
            </div>
          </Link>
          <Link
            to={`${path}/manage`}
            className={`${itemLink} ${manage ? itemLinkActive : ''}`}
            onClick={() => setRoute(`${path}/manage`)}
          >
            <div className={itemTitle}>
              <div className={itemTitlePos}>
                <SettingOutlined />
                Administrar
              </div>
            </div>
            <div className={itemArrow}>
              <RightOutlined />
            </div>
          </Link>
        </div>
      </div>
      <div className={logOutItem}>
        <div onClick={logOut} className={logOutBtn}>
          <LogoutOutlined />
          Cerrar sesión
        </div>
        <div className={waveContainer}>
          <div className={customShapeDivider}>
            <svg
              data-name="Layer 1"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 1200 120"
              preserveAspectRatio="none"
            >
              <path
                d="M985.66,92.83C906.67,72,823.78,31,743.84,14.19c-82.26-17.34-168.06-16.33-250.45.39-57.84,11.73-114,31.07-172,41.86A600.21,600.21,0,0,1,0,27.35V120H1200V95.8C1132.19,118.92,1055.71,111.31,985.66,92.83Z"
                className={shapeFill}
              ></path>
            </svg>
          </div>
          <div className={customShapeDivider2}>
            <svg
              data-name="Layer 1"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 1200 120"
              preserveAspectRatio="none"
            >
              <path
                d="M985.66,92.83C906.67,72,823.78,31,743.84,14.19c-82.26-17.34-168.06-16.33-250.45.39-57.84,11.73-114,31.07-172,41.86A600.21,600.21,0,0,1,0,27.35V120H1200V95.8C1132.19,118.92,1055.71,111.31,985.66,92.83Z"
                className={shapeFill}
              ></path>
            </svg>
          </div>
        </div>
      </div>
      {redirectLogin && <Redirect to="/signPage" />}
    </div>
  );
};

export default SideBar;
